export default "__VITE_ASSET__BfPtqrdQ__"